import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { about, allInOne, barkodOxuyucu, barkodPrinter, barkodProcessor, cardReader, carousel2, dataTerminal, hero, pulQutulari, blogs1, blogs2, blogs3, project1, project2, project3, project4, project5, project6, rightArrow, service1, service2, service3, service4, rightUp, office1, office2 } from '../../assets/index';
import { useTranslation } from 'react-i18next';
import HeaderOther from '../../Components/HeaderOther/HeaderOther';
import Title from '../../Components/Title/Title';


const Offices = () => {

  const { t, i18n } = useTranslation();
 
  const projects = [
    { id: 1, image: office1, room: 3, field: 90 },
    { id: 2, image: office2, room: 4, field: 130 },
    { id: 3, image: office1, room: 3, field: 100 },
    { id: 4, image: office2, room: 4, field: 100 },
    { id: 5, image: office1, room: 2, field: 70 },
    { id: 6, image: office2, room: 1, field: 27 },
    { id: 7, image: office1, room: 2, field: 67 },
    { id: 8, image: office2, room: 2, field: 55 },
  ];

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  return (
   <>
   <HeaderOther/>
   <Title title="Ofislər"/>
   <div className='max-w-containerSm md:max-w-container mx-auto pt-[44px] md:pt-[230px]'>
   <div>
      <p className='text-[24px] md:text-[40px] font-bold md:font-semibold font-barlow mb-10'>Geniş və Təchiz Olunmuş <span className='font-barlow text-[#E11E26]'>Ofis Sahələri</span></p>
      <div className='grid grid-cols-1 md:grid-cols-4 gap-4'>
        {projects.map((project) => (
          <a key={project.id} href={`/offices/${project.id}`}>
            <div className="relative -z-50 md:w-[315px] h-[313px] rounded-[20px] border-[2px] border-[#EFEFEF]">
              <img className="rounded-t-[20px] mb-4 w-full h-[248px]" src={project.image} alt={`Project ${project.id}`} />
              <p className='ml-3 text-[20px]'>{project.room} otaqlı <span>{project.field} m2</span></p>
            </div>
          </a>
        ))}
      </div>
    </div>
   </div>  </>
  );
};
 
export default Offices; 